import { APP_NAME } from 'app-config'

import { IResponseResult } from 'models/api.model'

import { ApiService } from 'services/api.service'
import { RetenoEvents } from 'services/retenoLogger.service'

import { RequestMethod } from 'root-constants'
import { TAppName } from 'root-types'

export class RetenoEventsApi {
  private readonly appName: TAppName = APP_NAME
  private readonly api: ApiService

  constructor(api: ApiService) {
    this.api = api
  }

  sendRetenoEvent(
    uuid: string,
    event: RetenoEvents,
    eventProperty?: Record<string, string>,
  ): Promise<IResponseResult<never>> {
    const options = {
      method: RequestMethod.POST,
      body: {
        app_name: this.appName,
        uuid,
        type: event,
        ...(eventProperty &&
          Object.keys(eventProperty).length && { fields: eventProperty }),
      },
    }

    return this.api.makeRequest<never>('v2/reteno/event', options)
  }
}
